import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Checkbox from "@mui/material/Checkbox";
import Radio from "@mui/material/Radio";
import Autocomplete from "@mui/material/Autocomplete";
import Chip from "@mui/material/Chip";
import Slide from "@mui/material/Slide";
import Fade from "@mui/material/Fade";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloseIcon from "@mui/icons-material/Close";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import AddIcon from "@mui/icons-material/Add";
import { showSuccessToast, showErrorToast } from "../../../../app/utils/helpers";
import {
    addEditQuestion,
    addEditAptitude,
    setAddQuestionModalVisibility,
    addEditQuestionAnswers,
    setCurrentQuestion,
    setSelectedAptitudeForQuestion,
    deleteQuestionAnswer,
    setQuestionsBank,
    setAddQuestionFromTree,
} from "../../vcompSlice";
import { Localize } from "../../../../app/lang/langs";
import Langs from "../../../../app/lang/langs";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const MobileAddQuestionModal = () => {
    const dispatch = useDispatch();

    const element = useSelector((state) => state.vcomp.selectedAptitudeForQuestion);
    const currentQuestion = useSelector((state) => state.vcomp.currentQuestion);
    const onCreateProject = useSelector((state) => state.vcomp.onCreateProject);
    const questionDialogVisible = useSelector((state) => state.vcomp.addQuestionModalVisibility);
    const questionsBank = useSelector((state) => state.vcomp.questionsBank);
    const addQuestionFromTree = useSelector((state) => state.vcomp.addQuestionFromTree);

    const [selectedQuestions, setSelectedQuestions] = useState([]);
    const [questionNom, setQuestionNom] = useState(currentQuestion?.question || "");
    const [typeQuestions, setTypeQuestionsState] = useState(currentQuestion?.type || "single");
    const [responses, setResponses] = useState(currentQuestion?.responses || []);
    const [selectedView, setSelectedView] = useState(1);

    const typesQuestionsOptions = [
        { label: Localize("Single"), value: "single" },
        { label: Localize("Multi"), value: "multi" },
    ];

    const questions = questionsBank.map((question) => ({
        label: question.question,
        value: question.id,
    }));

    useEffect(() => {
        if (currentQuestion) {
            setQuestionNom(currentQuestion.question || "");
            setTypeQuestionsState(currentQuestion.type || "single");

            const sortedResponses = (currentQuestion.options ? [...currentQuestion.options] : []).sort(
                (a, b) => a.pos - b.pos
            );

            const responsesWithCorrectAnswers = sortedResponses.map((response) => ({
                ...response,
                isTrue: currentQuestion.correct_answers.includes(response.id),
            }));

            setResponses(responsesWithCorrectAnswers);
        } else {
            setQuestionNom("");
            setTypeQuestionsState("single");
            setResponses([]);
        }
    }, [currentQuestion]);

    const addResponse = () => {
        if (responses.length < 5) {
            setResponses([...responses, { value: "", isTrue: false }]);
        } else {
            showErrorToast("Vous ne pouvez pas ajouter plus de 5 réponses.");
        }
    };

    const updateResponse = (index, field, value) => {
        const updatedResponses = [...responses];

        if (field === "isTrue" && typeQuestions === "single") {
            updatedResponses.forEach((response, i) => {
                updatedResponses[i] = { ...response, isTrue: false };
            });
        }

        updatedResponses[index] = { ...updatedResponses[index], [field]: value };

        setResponses(updatedResponses);
    };

    const removeResponse = (index) => {
        const responseToDelete = responses[index];

        const updatedResponses = responses.filter((_, i) => i !== index);
        setResponses(updatedResponses);

        if (!element) {
            // Cas où element est null : nous travaillons sur les questions globales
            const updatedQuestions = questionsBank.map((q) =>
                q.id === currentQuestion.id
                    ? { ...currentQuestion, options: updatedResponses }
                    : q
            );

            if (responseToDelete.id) {
                dispatch(deleteQuestionAnswer({ id: responseToDelete.id }));
            }

            // Mise à jour des questions globales
            dispatch(setQuestionsBank([...updatedQuestions]));
        } else {
            // Cas où element n'est pas null : nous travaillons sur les questions spécifiques à l'élément
            const updatedQuestions = element.questions.map((q) =>
                q.id === currentQuestion.id
                    ? { ...currentQuestion, options: updatedResponses }
                    : q
            );

            if (responseToDelete.id) {
                dispatch(deleteQuestionAnswer({ id: responseToDelete.id }));
                dispatch(
                    addEditAptitude({
                        ...element,
                        questions: updatedQuestions,
                    })
                );
            }

            // Sélection de l'élément mis à jour
            dispatch(
                setSelectedAptitudeForQuestion({
                    ...element,
                    questions: updatedQuestions,
                })
            );
        }
    };

    const handleSave = async () => {
        if (selectedView === 0) {
            if (!element) {
                showErrorToast("Aucune aptitude sélectionnée.");
                return;
            }

            try {
                // Pour chaque question sélectionnée, mettez à jour pour ajouter id_aptitude
                await Promise.all(
                    selectedQuestions.map(async (questionId) => {
                        const question = questionsBank.find((q) => q.id === questionId);
                        if (question) {
                            const updatedQuestion = {
                                ...question,
                                id_aptitude: element.id,
                            };
                            await dispatch(addEditQuestion(updatedQuestion)).unwrap();
                        }
                    })
                );

                // Mettez à jour les questions de l'aptitude dans le store Redux
                const updatedQuestions = [
                    ...(element.questions || []),
                    ...questionsBank.filter((q) => selectedQuestions.includes(q.id)),
                ];

                dispatch(
                    addEditAptitude({
                        ...element,
                        questions: updatedQuestions,
                    })
                );

                dispatch(
                    setSelectedAptitudeForQuestion({
                        ...element,
                        questions: updatedQuestions,
                    })
                );

                const updatedQuestionsBank = questionsBank.filter(
                    (q) => !selectedQuestions.includes(q.id)
                );
                dispatch(setQuestionsBank(updatedQuestionsBank));

                setSelectedView(1);
                setSelectedQuestions([]);
                closeQuestionDialog();
            } catch (error) {
                console.error("Échec de l'ajout des questions à l'aptitude :", error);
                showErrorToast("Échec de l'ajout des questions.");
            }
        } else if (selectedView === 1) {
            const questionData = {
                id_project: onCreateProject?.id || null,
                id: currentQuestion?.id || null,
                id_aptitude: element?.id || null,
                lang: "en",
                question: questionNom,
                type: typeQuestions,
                pos:
                    currentQuestion?.pos ||
                    (element?.questions.length + 1) ||
                    questionsBank.length + 1,
                correct_answers: [],
            };

            const questionModified = currentQuestion
                ? JSON.stringify({
                      question: currentQuestion.question,
                      type: currentQuestion.type,
                      correct_answers: currentQuestion.correct_answers,
                  }) !==
                  JSON.stringify({
                      question: questionData.question,
                      type: questionData.type,
                      correct_answers: questionData.correct_answers,
                  })
                : true;

            try {
                let questionId = currentQuestion?.id;

                if (questionModified || !currentQuestion) {
                    const questionResult = await dispatch(addEditQuestion(questionData)).unwrap();
                    questionId =
                        questionResult.responseData?.id_db ||
                        currentQuestion?.id ||
                        questionResult.responseData?.id;

                    dispatch(
                        setCurrentQuestion({
                            ...questionData,
                            id: questionId,
                        })
                    );
                }

                const updatedResponses = await Promise.all(
                    responses.map(async (response, index) => {
                        const responseData = {
                            id: response.id || null,
                            id_question: questionId,
                            value: response.value,
                            pos: index + 1,
                        };

                        const originalResponse = currentQuestion?.options.find(
                            (opt) => opt.id === response.id
                        );

                        const responseModified =
                            !originalResponse ||
                            JSON.stringify({
                                value: originalResponse.value,
                                pos: originalResponse.pos,
                            }) !==
                                JSON.stringify({
                                    value: response.value,
                                    pos: responseData.pos,
                                });

                        if (responseModified || !response.id) {
                            const responseResult = await dispatch(
                                addEditQuestionAnswers(responseData)
                            ).unwrap();
                            return {
                                ...response,
                                id: responseResult.responseData?.id_db || response.id,
                                pos: index + 1,
                            };
                        }
                        return response;
                    })
                );

                const correctAnswers = updatedResponses
                    .filter((response) => response.isTrue)
                    .map((response) => response.id);

                if (correctAnswers.length > 0) {
                    const updatedQuestionData = {
                        ...questionData,
                        correct_answers: correctAnswers,
                        id: questionId,
                    };

                    await dispatch(addEditQuestion(updatedQuestionData)).unwrap();
                }

                const responsesModified =
                    JSON.stringify(currentQuestion?.options || []) !==
                    JSON.stringify(updatedResponses);

                if (questionModified || responsesModified) {
                    let updatedQuestions;

                    if (!element) {
                        // Cas où element est null : nous devons traiter les questions globalement
                        if (!currentQuestion) {
                            // Ajouter la nouvelle question à la liste existante des questions dans questionsBank
                            updatedQuestions = [
                                ...questionsBank,
                                {
                                    ...questionData,
                                    id: questionId,
                                    options: updatedResponses,
                                    correct_answers: correctAnswers,
                                },
                            ];
                        } else {
                            updatedQuestions = questionsBank.map((q) =>
                                q.id === currentQuestion.id
                                    ? {
                                          ...questionData,
                                          id: questionId,
                                          options: updatedResponses,
                                          correct_answers: correctAnswers,
                                      }
                                    : q
                            );
                        }

                        // Mise à jour des questions globalement
                        dispatch(setQuestionsBank([...updatedQuestions]));
                    } else {
                        // Cas où element n'est pas null : mise à jour des questions spécifiques à l'élément
                        if (!currentQuestion) {
                            updatedQuestions = [
                                ...element.questions,
                                {
                                    ...questionData,
                                    id: questionId,
                                    options: updatedResponses,
                                    correct_answers: correctAnswers,
                                },
                            ];
                        } else {
                            updatedQuestions = element.questions.map((q) =>
                                q.id === currentQuestion.id
                                    ? {
                                          ...questionData,
                                          id: questionId,
                                          options: updatedResponses,
                                          correct_answers: correctAnswers,
                                      }
                                    : q
                            );
                        }

                        // Mise à jour de l'aptitude et des questions associées
                        dispatch(
                            addEditAptitude({
                                id: element.id,
                                nom: element.label,
                                coef: element.coef,
                                pos: element.pos,
                                description: element.description,
                                type: element.type,
                                id_category_default: element.id_category_default,
                                visibility: element.visibility,
                                aspect: element.aspect,
                                questions: updatedQuestions,
                            })
                        );

                        // Sélection de l'élément mis à jour
                        dispatch(
                            setSelectedAptitudeForQuestion({
                                ...element,
                                questions: [...updatedQuestions],
                            })
                        );
                    }

                    // Fermeture du dialogue
                    closeQuestionDialog();
                }

                closeQuestionDialog();
            } catch (error) {
                console.error("Failed to save question or update aptitude:", error);
            }
        }
    };

    const closeQuestionDialog = () => {
        dispatch(setAddQuestionModalVisibility(false));
        dispatch(setCurrentQuestion(null));
        dispatch(setAddQuestionFromTree(false));
    };

    const setTypeQuestions = (type) => {
        if (type === "single") {
            const updatedResponses = responses.map((response, index) => ({
                ...response,
                isTrue: index === 0 ? response.isTrue : false,
            }));
            setResponses(updatedResponses);
        }
        setTypeQuestionsState(type);
    };

    const isSaveDisabled =
        selectedView === 1 &&
        (!questionNom ||
            responses.length < 2 ||
            responses.some((r) => !r.value) ||
            !responses.some((r) => r.isTrue));

    const handleViewChange = (event, newView) => {
        if (newView != null) {
            setSelectedView(newView);
        }
    };

    // Map selectedQuestions (array of ids) to full option objects for Autocomplete
    const selectedQuestionObjects = questions.filter((q) =>
        selectedQuestions.includes(q.value)
    );

    return (
        <Dialog
            fullScreen
            open={questionDialogVisible}
            onClose={closeQuestionDialog}
            TransitionComponent={Transition}
            sx={{ zIndex: 1600 }}
        >
            {/* Sticky AppBar */}
            <AppBar
                position="sticky"
                elevation={0}
                sx={{
                    bgcolor: "#fff",
                    borderBottom: "1px solid rgba(0,0,0,0.08)",
                }}
            >
                <Toolbar sx={{ justifyContent: "space-between", minHeight: 56 }}>
                    <IconButton
                        edge="start"
                        onClick={closeQuestionDialog}
                        sx={{ color: "#4b5263" }}
                    >
                        <ArrowBackIcon />
                    </IconButton>
                    <Typography
                        variant="subtitle1"
                        sx={{
                            fontWeight: 600,
                            color: "#111318",
                            textAlign: "center",
                            flex: 1,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            mx: 1,
                            fontSize: "0.95rem",
                        }}
                    >
                        {currentQuestion
                            ? Localize("Edit_Question")
                            : Localize("Add_Question")}
                    </Typography>
                    <IconButton
                        edge="end"
                        onClick={closeQuestionDialog}
                        sx={{ color: "#4b5263" }}
                    >
                        <CloseIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>

            {/* Content */}
            <Box
                sx={{
                    flex: 1,
                    overflow: "auto",
                    WebkitOverflowScrolling: "touch",
                    bgcolor: "#fafbfc",
                    pb: "200px",
                }}
            >
                {/* View Toggle */}
                {!currentQuestion && !addQuestionFromTree && (
                    <Box sx={{ px: 2, pt: 2 }}>
                        <ToggleButtonGroup
                            value={selectedView}
                            exclusive
                            onChange={handleViewChange}
                            fullWidth
                            sx={{
                                bgcolor: "rgba(0,0,0,0.04)",
                                borderRadius: "12px",
                                p: 0.5,
                                "& .MuiToggleButton-root": {
                                    border: "none",
                                    borderRadius: "10px",
                                    textTransform: "none",
                                    fontWeight: 600,
                                    fontSize: "0.82rem",
                                    color: "#777",
                                    py: 1,
                                    transition: "all 0.2s ease",
                                    "&.Mui-selected": {
                                        bgcolor: "#fff",
                                        color: "#FF9015",
                                        boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
                                        "&:hover": {
                                            bgcolor: "#fff",
                                        },
                                    },
                                },
                            }}
                        >
                            <ToggleButton value={0}>
                                <Langs str="Questions Publiques" />
                            </ToggleButton>
                            <ToggleButton value={1}>
                                <Langs str="Créer une Question" />
                            </ToggleButton>
                        </ToggleButtonGroup>
                    </Box>
                )}

                {/* View 0: Public Questions */}
                {selectedView === 0 && (
                    <Fade in timeout={250}>
                        <Box sx={{ px: 2, pt: 3 }}>
                            <Typography
                                variant="body2"
                                sx={{
                                    fontWeight: 600,
                                    color: "#333",
                                    mb: 1.5,
                                    fontSize: "0.9rem",
                                }}
                            >
                                Sélectionnez des questions publiques
                            </Typography>
                            <Autocomplete
                                multiple
                                options={questions}
                                getOptionLabel={(option) => option.label || ""}
                                value={selectedQuestionObjects}
                                onChange={(event, newValue) => {
                                    setSelectedQuestions(newValue.map((q) => q.value));
                                }}
                                isOptionEqualToValue={(option, value) =>
                                    option.value === value.value
                                }
                                disableCloseOnSelect
                                renderTags={(value, getTagProps) =>
                                    value.map((option, index) => (
                                        <Chip
                                            {...getTagProps({ index })}
                                            key={option.value}
                                            label={option.label}
                                            size="small"
                                            sx={{
                                                bgcolor: "rgba(255,144,21,0.1)",
                                                color: "#FF9015",
                                                fontWeight: 500,
                                                fontSize: "0.8rem",
                                                borderRadius: "8px",
                                                "& .MuiChip-deleteIcon": {
                                                    color: "rgba(255,144,21,0.5)",
                                                    "&:hover": {
                                                        color: "#FF9015",
                                                    },
                                                },
                                            }}
                                        />
                                    ))
                                }
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Sélectionnez des questions"
                                        variant="outlined"
                                        sx={{
                                            "& .MuiOutlinedInput-root": {
                                                borderRadius: "12px",
                                                fontSize: "16px",
                                                bgcolor: "#fff",
                                                "& fieldset": {
                                                    borderColor: "rgba(0,0,0,0.12)",
                                                },
                                                "&:hover fieldset": {
                                                    borderColor: "rgba(255,144,21,0.4)",
                                                },
                                                "&.Mui-focused fieldset": {
                                                    borderColor: "#FF9015",
                                                },
                                            },
                                            "& input": {
                                                fontSize: "16px",
                                            },
                                        }}
                                    />
                                )}
                                slotProps={{
                                    popper: {
                                        sx: { zIndex: 1700 },
                                    },
                                }}
                                sx={{ width: "100%" }}
                            />
                        </Box>
                    </Fade>
                )}

                {/* View 1: Create/Edit Question */}
                {selectedView === 1 && (
                    <Fade in timeout={250}>
                        <Box sx={{ px: 2, pt: 2.5 }}>
                            {/* Question Name */}
                            <Box sx={{ mb: 2.5 }}>
                                <Typography
                                    variant="body2"
                                    sx={{
                                        fontWeight: 600,
                                        color: "#333",
                                        mb: 1,
                                        fontSize: "0.85rem",
                                    }}
                                >
                                    <Langs str="Name" />
                                </Typography>
                                <TextField
                                    fullWidth
                                    value={questionNom}
                                    onChange={(e) => setQuestionNom(e.target.value)}
                                    placeholder={
                                        currentQuestion
                                            ? "Edit question name"
                                            : "Enter question name"
                                    }
                                    variant="outlined"
                                    sx={{
                                        "& .MuiOutlinedInput-root": {
                                            borderRadius: "12px",
                                            minHeight: 48,
                                            bgcolor: "#fff",
                                            "& fieldset": {
                                                borderColor: "rgba(0,0,0,0.12)",
                                            },
                                            "&:hover fieldset": {
                                                borderColor: "rgba(255,144,21,0.4)",
                                            },
                                            "&.Mui-focused fieldset": {
                                                borderColor: "#FF9015",
                                            },
                                        },
                                        "& input": {
                                            fontSize: "16px",
                                            padding: "12px 16px",
                                        },
                                    }}
                                />
                            </Box>

                            {/* Type Selector */}
                            <Box sx={{ mb: 2.5 }}>
                                <Typography
                                    variant="body2"
                                    sx={{
                                        fontWeight: 600,
                                        color: "#333",
                                        mb: 1,
                                        fontSize: "0.85rem",
                                    }}
                                >
                                    Type
                                </Typography>
                                <FormControl fullWidth>
                                    <Select
                                        value={typeQuestions}
                                        onChange={(e) => setTypeQuestions(e.target.value)}
                                        displayEmpty
                                        MenuProps={{
                                            sx: { zIndex: 1700 },
                                        }}
                                        sx={{
                                            borderRadius: "12px",
                                            minHeight: 48,
                                            bgcolor: "#fff",
                                            fontSize: "16px",
                                            "& .MuiOutlinedInput-notchedOutline": {
                                                borderColor: "rgba(0,0,0,0.12)",
                                            },
                                            "&:hover .MuiOutlinedInput-notchedOutline": {
                                                borderColor: "rgba(255,144,21,0.4)",
                                            },
                                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                borderColor: "#FF9015",
                                            },
                                        }}
                                    >
                                        {typesQuestionsOptions.map((opt) => (
                                            <MenuItem key={opt.value} value={opt.value}>
                                                {opt.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box>

                            {/* Responses */}
                            <Box sx={{ mb: 2 }}>
                                <Typography
                                    variant="body2"
                                    sx={{
                                        fontWeight: 600,
                                        color: "#333",
                                        mb: 1.5,
                                        fontSize: "0.85rem",
                                    }}
                                >
                                    <Langs str="Responses" />
                                </Typography>

                                {responses.map((response, index) => (
                                    <Fade
                                        in
                                        key={index}
                                        timeout={200 + index * 60}
                                    >
                                        <Box
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 1,
                                                mb: 1.5,
                                                bgcolor: "#fff",
                                                borderRadius: "12px",
                                                border: "1px solid rgba(0,0,0,0.08)",
                                                p: 1,
                                                transition: "all 0.15s ease",
                                            }}
                                        >
                                            {/* Correct answer toggle */}
                                            {typeQuestions === "single" ? (
                                                <Radio
                                                    checked={response.isTrue}
                                                    onChange={(e) =>
                                                        updateResponse(
                                                            index,
                                                            "isTrue",
                                                            e.target.checked
                                                        )
                                                    }
                                                    disabled={
                                                        typeQuestions === "single" &&
                                                        response.isTrue &&
                                                        responses.filter((r) => r.isTrue)
                                                            .length === 1
                                                    }
                                                    sx={{
                                                        color: "rgba(0,0,0,0.25)",
                                                        "&.Mui-checked": {
                                                            color: "#FF9015",
                                                        },
                                                        p: 0.5,
                                                    }}
                                                />
                                            ) : (
                                                <Checkbox
                                                    checked={response.isTrue}
                                                    onChange={(e) =>
                                                        updateResponse(
                                                            index,
                                                            "isTrue",
                                                            e.target.checked
                                                        )
                                                    }
                                                    sx={{
                                                        color: "rgba(0,0,0,0.25)",
                                                        "&.Mui-checked": {
                                                            color: "#FF9015",
                                                        },
                                                        p: 0.5,
                                                    }}
                                                />
                                            )}

                                            {/* Response text */}
                                            <TextField
                                                fullWidth
                                                value={response.value}
                                                onChange={(e) =>
                                                    updateResponse(
                                                        index,
                                                        "value",
                                                        e.target.value
                                                    )
                                                }
                                                placeholder={`${Localize("Response")} ${index + 1}`}
                                                variant="standard"
                                                InputProps={{
                                                    disableUnderline: true,
                                                }}
                                                sx={{
                                                    "& input": {
                                                        fontSize: "16px",
                                                        py: 0.75,
                                                    },
                                                }}
                                            />

                                            {/* Delete */}
                                            <IconButton
                                                size="small"
                                                onClick={() => removeResponse(index)}
                                                aria-label={`Supprimer réponse ${index + 1}`}
                                                sx={{
                                                    color: "#d32f2f",
                                                    opacity: 0.6,
                                                    "&:hover": { opacity: 1 },
                                                    "&:active": {
                                                        transform: "scale(0.9)",
                                                    },
                                                    transition: "all 0.15s ease",
                                                    p: 0.5,
                                                }}
                                            >
                                                <DeleteOutlineIcon
                                                    sx={{ fontSize: 20 }}
                                                />
                                            </IconButton>
                                        </Box>
                                    </Fade>
                                ))}

                                {/* Add Response Button */}
                                <Button
                                    fullWidth
                                    variant="outlined"
                                    startIcon={<AddIcon />}
                                    onClick={addResponse}
                                    sx={{
                                        mt: 1,
                                        borderColor: "rgba(255,144,21,0.4)",
                                        color: "#FF9015",
                                        fontWeight: 600,
                                        textTransform: "none",
                                        borderRadius: "12px",
                                        minHeight: 48,
                                        fontSize: "0.9rem",
                                        borderStyle: "dashed",
                                        borderWidth: "1.5px",
                                        "&:hover": {
                                            borderColor: "#FF9015",
                                            bgcolor: "rgba(255,144,21,0.04)",
                                        },
                                        "&:active": {
                                            transform: "scale(0.98)",
                                        },
                                        transition: "all 0.15s ease",
                                    }}
                                >
                                    <Langs str="Add_Response" />
                                </Button>
                            </Box>
                        </Box>
                    </Fade>
                )}
            </Box>

            {/* Sticky Bottom Bar */}
            <Box
                sx={{
                    position: "sticky",
                    bottom: 0,
                    background:
                        "linear-gradient(to top, rgba(255,255,255,0.92) 50%, rgba(255,255,255,0.78) 100%)",
                    backdropFilter: "blur(18px) saturate(1.6)",
                    WebkitBackdropFilter: "blur(18px) saturate(1.6)",
                    borderTop: "1px solid rgba(255, 144, 21, 0.15)",
                    px: 2,
                    py: 2,
                    pb: "calc(env(safe-area-inset-bottom, 0px) + 16px)",
                    display: "flex",
                    gap: 1.5,
                }}
            >
                <Button
                    fullWidth
                    variant="outlined"
                    onClick={closeQuestionDialog}
                    sx={{
                        border: "1.5px solid rgba(0, 0, 0, 0.12)",
                        color: "#4b5263",
                        fontWeight: 600,
                        textTransform: "none",
                        borderRadius: "14px",
                        minHeight: 48,
                        fontSize: "0.93rem",
                        "&:hover": {
                            border: "1.5px solid rgba(0, 0, 0, 0.2)",
                            bgcolor: "rgba(0,0,0,0.02)",
                        },
                        "&:active": {
                            transform: "scale(0.98)",
                        },
                        transition: "all 0.15s ease",
                    }}
                >
                    <Langs str="Cancel" />
                </Button>
                <Button
                    fullWidth
                    variant="contained"
                    disableElevation
                    onClick={handleSave}
                    disabled={isSaveDisabled}
                    sx={{
                        background:
                            "linear-gradient(135deg, #FF9015 0%, #FFA940 100%)",
                        color: "#fff",
                        fontWeight: 650,
                        textTransform: "none",
                        borderRadius: "14px",
                        minHeight: 48,
                        fontSize: "0.93rem",
                        boxShadow:
                            "0 4px 16px rgba(255, 144, 21, 0.40), 0 8px 32px rgba(255, 144, 21, 0.20), inset 0 1px 0 rgba(255, 255, 255, 0.2)",
                        "&:hover": {
                            background:
                                "linear-gradient(135deg, #e07400 0%, #FF9015 100%)",
                        },
                        "&:active": {
                            transform: "scale(0.98)",
                            transition: "all 100ms ease",
                        },
                        "&.Mui-disabled": {
                            background: "rgba(0,0,0,0.08)",
                            color: "rgba(0,0,0,0.3)",
                            boxShadow: "none",
                        },
                        transition:
                            "all 250ms cubic-bezier(0.4, 0, 0.2, 1)",
                    }}
                >
                    <Langs str="SAVE" />
                </Button>
            </Box>
        </Dialog>
    );
};

export default MobileAddQuestionModal;
